// extracted by mini-css-extract-plugin
export default {"menuButton":"Chart-module__menuButton___jH68V","limitWarningIcon":"Chart-module__limitWarningIcon___VkaDL"};